<script>

export default
{
    name: 'contact-us',

    render () 
    {
        return (
            <div id='contact-us-view'>
                <div class='title'>Nous contacter</div>
                <div class='contact-info'>
                    <h2>Support</h2>
                    Vous pouvez contacter le support à <b>support@app-maville.com</b> ou en utilisant le chat en ligne à l'aide de la bulle en bas à droite.
                    <h2>Développement</h2>
                    Pour toute question technique, veuillez vous adresser à <b>dev@app-maville.com</b>.
                    <h2>Autre</h2>
                    Pour toute autre demande, nous sommes joignables à <b>contact@app-maville.com</b> ou par téléphone au <b>06 45 07 37 68</b>.
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#contact-us-view
{
    width: 100%;
    padding-top: 15vh;

    & .title
    {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        font-size: 6vw;

        .OnTablet({ font-size: 4.5vw; });
        .OnDesktop({ font-size: 2vw; });
    }

    & .contact-info
    {
        margin-top: 10vh;
        margin-bottom: 10vh;
        width: 90%;
        margin-left: 5%;

        .OnTablet({
            width: 70%;
            margin-left: 15%;
        });

        .OnDesktop({
            width: 60%;
            margin-left: 20%;
        });

        h2
        {
            margin: 2vh 0;
        }

        b
        {
            color: var(--theme-accent-color);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ContactUs.vue